import { render } from "./ScrollIcon.vue?vue&type=template&id=dfe726f6&scoped=true"
import script from "./ScrollIcon.vue?vue&type=script&lang=js"
export * from "./ScrollIcon.vue?vue&type=script&lang=js"

import "./ScrollIcon.vue?vue&type=style&index=0&id=dfe726f6&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/VueJS/marco-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe726f6"]])

export default __exports__